import { render } from "./UserCard.vue?vue&type=template&id=a77e3e3a&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=a77e3e3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a77e3e3a"

export default script